import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../urunDiv.css';
import iceAmericano from '../../../../assets/menu/icecekler/soguk-kahveler/ice-americano.jpeg';
import iceLatte from '../../../../assets/menu/icecekler/soguk-kahveler/ice-latte.jpeg';
import iceCappuccino from '../../../../assets/menu/icecekler/soguk-kahveler/ice-cappuccino.jpeg';
import frappe from '../../../../assets/menu/icecekler/soguk-kahveler/frappe.jpeg';
import coldBrew from '../../../../assets/menu/icecekler/soguk-kahveler/cold-brew.jpeg';
import affogato from '../../../../assets/menu/icecekler/soguk-kahveler/affogato.jpeg';
import iceMocha from '../../../../assets/menu/icecekler/soguk-kahveler/ice-mocha.jpeg';
import maviCilekliIceLatte from '../../../../assets/menu/icecekler/soguk-kahveler/mavi-cilekli-ice-latte.jpeg';
import italyanKaramel from '../../../../assets/menu/icecekler/soguk-kahveler/italyan-karamel-ice-latte.jpeg';
import tuzluKaramel from '../../../../assets/menu/icecekler/soguk-kahveler/tuzlu-karamel-ice-latte.jpeg';
import baileysIceLatte from '../../../../assets/menu/icecekler/soguk-kahveler/baileys-ice-latte.jpeg';
import virginiaCoffee from '../../../../assets/menu/icecekler/soguk-kahveler/virginia-coffee.jpeg';
import wakaWaka from '../../../../assets/menu/icecekler/soguk-kahveler/waka-waka.jpeg';
import coolNut from '../../../../assets/menu/icecekler/soguk-kahveler/cool-nut.jpeg';
import oreoCoffee from '../../../../assets/menu/icecekler/soguk-kahveler/oreo-coffee.jpeg';
import kitirli from '../../../../assets/menu/icecekler/soguk-kahveler/kitirli.jpeg';
import sipsevdi from '../../../../assets/menu/icecekler/soguk-kahveler/sipsevdi.jpeg';
import sweetBaby from '../../../../assets/menu/icecekler/soguk-kahveler/sweet-baby.jpeg';
import melonSapka from '../../../../assets/menu/icecekler/soguk-kahveler/melon-sapka.jpeg';
import cheeseCake from '../../../../assets/menu/icecekler/soguk-kahveler/cheese-cake.jpeg';
import javaChip from '../../../../assets/menu/icecekler/soguk-kahveler/java-chip.jpeg';


const SogukKahveler = () => {
  const [selectedKahve, setSelectedKahve] = useState(null);
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const kahveKategorileri = {
    'Soğuk Kahveler': [
      {
        id: 1,
        name: 'İce Americano',
        price: '₺209,90',
        image: iceAmericano
      },
      {
        id: 2,
        name: 'İce Latte',
        price: '₺229,90',
        image: iceLatte
      },
      {
        id: 3,
        name: 'İce Cappuccino',
        price: '₺229,90',
        image: iceCappuccino
      },
      {
        id: 4,
        name: 'Frappe',
        price: '₺249,90',
        image: frappe
      },
      {
        id: 5,
        name: 'Cold Brew',
        price: '₺229,90',
        image: coldBrew
      },
      {
        id: 6,
        name: 'Affogato',
        price: '₺269,90',
        image: affogato
      },
      {
        id: 7,
        name: 'Çikolatalı Mocha',
        price: '₺249,90',
        image: iceMocha
      },
      {
        id: 8,
        name: 'Beyaz Çikolatalı Mocha',
        price: '₺249,90',
        image: iceMocha
      },
      {
        id: 9,
        name: 'Karamelli Mocha',
        price: '₺249,90',
        image: iceMocha
      },
    ],  
    'Soğuk Special Kahveler': [
      {
        id: 10,
        name: 'Mavi Çilekli Ice Latte',
        price: '₺239,90',
        image: maviCilekliIceLatte
      },
      {
        id: 11,
        name: 'İtalyan Karamel Ice Latte',
        price: '₺239,90',
        image: italyanKaramel
      },
      {
        id: 12,
        name: 'Tuzlu Karamel Ice Latte',
        price: '₺239,90',
        image: tuzluKaramel
      },
      {
        id: 13,
        name: 'Baileys Ice Latte (alkolsüz)',
        price: '₺239,90',
        image: baileysIceLatte
      },
      {
        id: 14,
        name: 'Virginia Coffee',
        price: '₺239,90',
        image: virginiaCoffee
      },
      {
        id: 15,
        name: 'Waka Waka',
        price: '₺239,90',
        image: wakaWaka
      },
      {
        id: 16,
        name: 'Cool Nut',
        price: '₺239,90',
        image: coolNut
      },
      {
        id: 17,
        name: 'Oreo Coffee',
        price: '₺239,90',
        image: oreoCoffee
      },
      {
        id: 18,
        name: 'Kıtırlı',
        price: '₺239,90',
        image: kitirli
      },
      {
        id: 19,
        name: 'Şıpsevdi',
        price: '₺239,90',
        image: sipsevdi
      },
      {
        id: 20,
        name: 'Sweet Baby',
        price: '₺239,90',
        image: sweetBaby
      },
      {
        id: 21,
        name: 'Melon Şapka',
        price: '₺239,90',
        image: melonSapka
      },
      {
        id: 22,
        name: 'Cheese Cake',
        price: '₺239,90',
        image: cheeseCake
      },
      {
        id: 23,
        name: 'Java Chip',
        price: '₺239,90',
        image: javaChip
      }
    ]
  };

  const handleKahveClick = (kahve) => {
    if (kahve.name === 'İce Americano') {
      navigate('/soguk-kahveler/ice-americano');
    } else if (kahve.name === 'İce Latte') {
      navigate('/soguk-kahveler/ice-latte');
    } else if (kahve.name === 'İce Cappuccino') {
      navigate('/soguk-kahveler/ice-cappuccino');
    } else if (kahve.name === 'Frappe') {
      navigate('/soguk-kahveler/frappe');
    } else if (kahve.name === 'Cold Brew') {
      navigate('/soguk-kahveler/cold-brew');
    } else if (kahve.name === 'Affogato') {
      navigate('/soguk-kahveler/affogato');
    } else if (kahve.name === 'Çikolatalı Mocha') {
      navigate('/soguk-kahveler/ice-cikolatali-mocha');
    } else if (kahve.name === 'Beyaz Çikolatalı Mocha') {
      navigate('/soguk-kahveler/ice-beyaz-cikolatali-mocha');
    } else if (kahve.name === 'Karamelli Mocha') {
      navigate('/soguk-kahveler/ice-karamelli-mocha');
    } else if (kahve.name === 'Mavi Çilekli Ice Latte') {
      navigate('/soguk-kahveler/mavi-cilekli-ice-latte');
    } else if (kahve.name === 'İtalyan Karamel Ice Latte') {
      navigate('/soguk-kahveler/italyan-karamel-ice-latte');
    } else if (kahve.name === 'Tuzlu Karamel Ice Latte') {
      navigate('/soguk-kahveler/tuzlu-karamel-ice-latte');
    } else if (kahve.name === 'Baileys Ice Latte (alkolsüz)') {
      navigate('/soguk-kahveler/baileys-ice-latte');
    } else if (kahve.name === 'Virginia Coffee') {
      navigate('/soguk-kahveler/virginia-coffee');
    } else if (kahve.name === 'Waka Waka') {
      navigate('/soguk-kahveler/waka-waka');
    } else if (kahve.name === 'Cool Nut') {
      navigate('/soguk-kahveler/cool-nut');
    } else if (kahve.name === 'Oreo Coffee') {
      navigate('/soguk-kahveler/oreo-coffee');
    } else if (kahve.name === 'Kıtırlı') {
      navigate('/soguk-kahveler/kitirli');
    } else if (kahve.name === 'Şıpsevdi') {
      navigate('/soguk-kahveler/sipsevdi');
    } else if (kahve.name === 'Sweet Baby') {
      navigate('/soguk-kahveler/sweet-baby');
    } else if (kahve.name === 'Melon Şapka') {
      navigate('/soguk-kahveler/melon-sapka');
    } else if (kahve.name === 'Cheese Cake') {
      navigate('/soguk-kahveler/cheese-cake');
    } else if (kahve.name === 'Java Chip') {
      navigate('/soguk-kahveler/java-chip');
    } else {
      setSelectedKahve(kahve);
    }
  };

  const handleBackToMenu = () => {
    setSelectedKahve(null);
  };

  if (selectedKahve) {
    return <KahveDetay kahve={selectedKahve} onBack={handleBackToMenu} />;
  }

  return (
    isPhone ? (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Soğuk Kahveler</h2>
        </div>
        
        {Object.entries(kahveKategorileri).map(([kategori, kahveler]) => (
          <div key={kategori}>
            <div className="container" style={{marginTop: '20px'}}>
              <h2 style={{marginLeft: 'auto', fontWeight: '700', marginTop: '0px' }}>{kategori}</h2>
            </div>
            <hr style={{color: '#D8D8D8'}} />
            <div className="urun-grid">
              {kahveler.map((kahve) => (
                <div 
                  key={kahve.id} 
                  className="urun-kart"
                  onClick={() => handleKahveClick(kahve)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="urun-bilgi">
                    <h3 className="urun-ad">{kahve.name}</h3>
                    <div className="urun-fiyat">{kahve.price}</div>
                  </div>
                  <div className="urun-resim">
                    <img src={kahve.image} alt={kahve.name} style={{
                      width: '80px',
                      height: '80px',
                      objectFit: 'cover',
                      borderRadius: '100px',
                    }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    ) : (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Soğuk Kahveler</h2>
        </div>
        
        {Object.entries(kahveKategorileri).map(([kategori, kahveler]) => (
          <div style={{marginBottom: '80px'}} key={kategori}>
            <div className="container" style={{marginTop: '20px'}}>
              <h2 style={{marginLeft: 'auto', fontWeight: '700', marginTop: '0px' }}>{kategori}</h2>
            </div>
            <hr style={{color: '#D8D8D8'}} />
            <div className="urun-grid-computer">
              {kahveler.map((kahve) => (
                <div 
                  key={kahve.id} 
                  className="urun-kart-computer"
                  onClick={() => handleKahveClick(kahve)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="urun-bilgi">
                    <h3 className="urun-ad-computer">{kahve.name}</h3>
                    <div className="urun-fiyat-computer">{kahve.price}</div>
                  </div>
                  <div className="urun-resim">
                    <img src={kahve.image} alt={kahve.name} style={{
                      width: '100px',
                      height: '100px',
                      objectFit: 'cover',
                      borderRadius: '100px',
                    }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    )
  );
};

export default SogukKahveler;
